var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStooling(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 49,
    viewBox: "0 0 49 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Component 362"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.166626,
    y: 0.5,
    width: 48,
    height: 48,
    rx: 16,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M36.1668 24.9276C36.1668 24.9276 32.7737 25.1759 29.8772 28.0724C26.9806 30.969 26.9806 35.2724 26.9806 35.2724M12.1666 24.8444C12.1666 24.8444 16.8011 25.341 19.0356 28.1548C21.2701 30.9686 21.2701 35.3548 21.2701 35.3548M12.6636 17.7281H18.1257C18.8112 17.7281 19.367 18.2839 19.367 18.9695C19.367 19.655 18.8112 20.2108 18.1257 20.2108H12.2498M36.0012 20.2094L29.8771 20.2094C29.1915 20.2094 28.6357 19.6536 28.6357 18.968C28.6357 18.2824 29.1915 17.7266 29.8771 17.7266L35.753 17.7266M12.8287 14.5C12.8287 14.5 12.1666 19.3828 12.1666 25.0931C12.1666 30.8034 21.2701 35.2724 21.2701 35.2724H26.8977C26.8977 35.2724 36.1666 30.7207 36.1666 25.0931C36.1666 19.4655 35.5046 14.5 35.5046 14.5H12.8287Z",
    stroke: "currentColor",
    strokeWidth: 1.3,
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStooling);
export default __webpack_public_path__ + "static/media/stooling.962d84e6651e048d88c4b368dcc1e6fa.svg";
export { ForwardRef as ReactComponent };